import { Injectable, signal, WritableSignal } from '@angular/core';
import { FolderInterface, FolderType } from '../../../core/interfaces/folder.interface';
import { AppInterface } from 'src/app/core/interfaces/app.interface';

@Injectable({
  providedIn: 'root',
})
export class FolderUiService {
  private isEditMode: WritableSignal<boolean> = signal(false);
  private readonly folderBeingRenamed: WritableSignal<FolderInterface | null> = signal(null);
  private readonly selectedFolder: WritableSignal<FolderInterface | null> = signal(null);
  public folders: FolderInterface[] = [];
  private suppressNextOutsideClick = false;

  setSelectedFolder(_folder: FolderInterface) {
    this.selectedFolder.set(_folder);
  }

  getSelectedFolder(): WritableSignal<FolderInterface | null> {
    return this.selectedFolder;
  }

  getIsEditMode() {
    return this.isEditMode();
  }

  toggleEditMode() {
    this.isEditMode.set(!this.isEditMode());
    this.setFolderBeingRenamed(null);
  }

  setFolderBeingRenamed(_folder: FolderInterface | null): void {
    this.folderBeingRenamed.set(_folder);
  }

  getFolderBeingRenamed(): WritableSignal<FolderInterface | null> {
    return this.folderBeingRenamed;
  }

  resetEditMode() {
    this.isEditMode.set(false);
    this.setFolderBeingRenamed(null);
  }

  setSuppressNextOutsideClick(): void {
    this.suppressNextOutsideClick = true;
  }

  consumeSuppressNextOutsideClick(): boolean {
    if (this.suppressNextOutsideClick) {
      this.suppressNextOutsideClick = false;
      return true;
    }
    return false;
  }

  selectFirstFolder(): void {
    this.selectedFolder.set(this.folders[0]);
  }

  getDefaultFolder(): FolderInterface | undefined {
    const sorted = this.folders
      .filter((f) => f.folderType === FolderType.FOLDER)
      .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
    return sorted[0] ?? this.folders[0];
  }

  getBookmarkableFolders(): FolderInterface[] {
    return this.folders.filter((f) => f.folderType === FolderType.FOLDER);
  }

  getFolderName(_app: AppInterface): string | undefined {
    return this.folders.find(
      (_folder) => _folder.id === _app.folderId,
    )?.name;
  }
}
